import { api } from "..";

export function createOrderRequest(data) {
  return api.post("/v1/order/create", data);
}

export function updateOrderRequest({ id, data }) {
  return api.put(`/v1/order/${id}`, data);
}

export function getOrderRequest({ params }) {
  return api.get(`/v1/order`, {
    params,
  });
}

export function getOrderByIdRequest({ id, params }) {
  return api.get(`/v1/order/${id}`, { params });
}

export function approveOrderRequest({ orderId, data }) {
  return api.post(`/v1/order/${orderId}/approve`, data);
}

export function cancelOrderRequest({ orderId, data }) {
  return api.post(`/v1/order/${orderId}/cancel`, data);
}

export function revokeOrderRequest({ orderId, data }) {
  return api.post(`/v1/order/${orderId}/approve-revoke`, data);
}